/* Maison Septième: product page behaviour (no dependencies) */
(() => {
  'use strict';

  /* ---------- Related products (recommendations API) ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.recommendations);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = doc.querySelector('[data-recommendations]');
      if (next && next.innerHTML.trim()) {
        el.innerHTML = next.innerHTML;
        el.querySelectorAll('[data-reveal]').forEach((n) => n.classList.add('is-visible'));
      }
    } catch (e) { /* recommendations are optional */ }
  });

  const root = document.querySelector('[data-product]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const form = root.querySelector('[data-product-form]');
  const idInput = root.querySelector('[data-variant-id]');
  const addBtn = root.querySelector('[data-add-button]');
  const addLabel = root.querySelector('[data-add-label]');
  const stickySubmit = root.querySelector('[data-sticky-submit]');

  const money = (cents) => {
    const opts = { style: 'currency', currency: data.currency };
    if (cents % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', opts).format(cents / 100);
  };

  /* ---------- Variant selection ---------- */
  const selectedOptions = () =>
    [...root.querySelectorAll('[data-option]')].map((fs) => {
      const checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });

  const scrollToMedia = (mediaId) => {
    if (!mediaId) return;
    const item = root.querySelector(`[data-media-id="${mediaId}"]`);
    const track = root.querySelector('[data-gallery-track]');
    if (!item || !track) return;
    if (window.matchMedia('(max-width: 989px)').matches) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
  };

  const onVariantChange = () => {
    const opts = selectedOptions();
    root.querySelectorAll('[data-option]').forEach((fs, i) => {
      const cur = fs.querySelector('[data-option-current]');
      if (cur) cur.textContent = opts[i] || '';
    });
    const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    if (!variant) {
      if (addBtn) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; }
      if (stickySubmit) stickySubmit.disabled = true;
      return;
    }
    idInput.value = variant.id;
    root.querySelectorAll('[data-price]').forEach((el) => { el.textContent = money(variant.price); });
    const compare = root.querySelector('[data-compare]');
    if (compare) { compare.hidden = !(variant.compare > variant.price); compare.textContent = money(variant.compare); }
    if (addBtn) { addBtn.disabled = !variant.available; addLabel.textContent = variant.available ? data.addLabel : 'Unavailable'; }
    if (stickySubmit) stickySubmit.disabled = !variant.available;
    const sv = root.querySelector('[data-sticky-variant]');
    if (sv) sv.textContent = variant.title === 'Default Title' ? '' : variant.title;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.pathname + url.search);
    scrollToMedia(variant.media);
    root.dispatchEvent(new CustomEvent('ms:variant-change', { detail: variant, bubbles: true }));
  };
  root.querySelectorAll('[data-option] input').forEach((input) => input.addEventListener('change', onVariantChange));

  /* ---------- Photo uploads: file name + preview ---------- */
  root.querySelectorAll('[data-upload]').forEach((zone) => {
    const input = zone.querySelector('input[type="file"]');
    const name = zone.querySelector('[data-upload-name]');
    const preview = zone.querySelector('[data-upload-preview]');
    const original = name ? name.textContent : '';
    ['dragenter', 'dragover'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.add('is-dragging')));
    ['dragleave', 'drop'].forEach((ev) => zone.addEventListener(ev, () => zone.classList.remove('is-dragging')));
    input.addEventListener('change', () => {
      const file = input.files && input.files[0];
      zone.classList.toggle('has-file', Boolean(file));
      zone.classList.remove('is-invalid');
      if (name) name.textContent = file ? file.name : original;
      if (preview) {
        preview.hidden = !file;
        preview.style.backgroundImage = file ? `url("${URL.createObjectURL(file)}")` : '';
      }
    });
    input.addEventListener('invalid', () => zone.classList.add('is-invalid'));
  });

  /* ---------- Submit: show a working state (file uploads can take a moment) ---------- */
  let addError = root.querySelector('[data-add-error]');
  if (!addError && addBtn) {
    addError = document.createElement('p');
    addError.className = 'ms-form-message ms-add-error';
    addError.setAttribute('role', 'alert');
    addError.hidden = true;
    addBtn.insertAdjacentElement('afterend', addError);
  }
  if (form) {
    form.addEventListener('submit', async (e) => {
      if (addBtn) { addBtn.classList.add('is-loading'); addLabel.textContent = 'Adding to your bag…'; }
      if (addError) addError.hidden = true;
      if (!window.msCart || !document.getElementById('MsCartDrawer')) return; // normal form post fallback
      e.preventDefault();
      try {
        const fd = new FormData(form);
        const extras = [];
        root.querySelectorAll('[data-addon]').forEach((group) => {
          const picked = group.querySelector('input[type="radio"]:checked');
          if (!picked || !picked.value) return;
          const variantLabel = root.querySelector('[data-sticky-variant]');
          const forLabel = [group.dataset.addonFor, variantLabel && variantLabel.textContent.trim()].filter(Boolean).join(', ');
          extras.push({ id: Number(picked.value), quantity: 1, properties: { For: forLabel } });
          fd.append(`properties[${group.querySelector('.ms-label').textContent.trim()}]`, picked.dataset.addonTitle);
        });
        await window.msCart.addToCart(fd, addBtn);
        if (extras.length && window.msCart.addItems) await window.msCart.addItems(extras);
      } catch (err) {
        if (addError) { addError.textContent = err.message; addError.hidden = false; }
      } finally {
        if (addBtn) { addBtn.classList.remove('is-loading'); addLabel.textContent = data.addLabel; }
      }
    });
  }

  /* ---------- Sticky bar ---------- */
  const sticky = root.querySelector('[data-sticky-buy]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      stickySubmit.tabIndex = show ? 0 : -1;
    });
    io.observe(addBtn);
    stickySubmit.addEventListener('click', () => {
      if (form.checkValidity()) {
        if (form.requestSubmit) form.requestSubmit(addBtn); else form.submit();
      } else {
        const invalid = document.querySelector(`[form="${form.id}"]:invalid`) || form.querySelector(':invalid');
        if (invalid) {
          const wrap = invalid.closest('[data-upload], .ms-field, .ms-option');
          if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => invalid.reportValidity(), 450);
        }
      }
    });
  }

  /* ---------- Gallery counter + zoom ---------- */
  const track = root.querySelector('[data-gallery-track]');
  const indexEl = root.querySelector('[data-gallery-index]');
  if (track && indexEl) {
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1;
      indexEl.textContent = String(i);
    }, { passive: true });
  }
  const zoom = root.querySelector('[data-zoom-dialog]');
  if (zoom && typeof zoom.showModal === 'function') {
    const img = zoom.querySelector('[data-zoom-img]');
    root.querySelectorAll('[data-zoom]').forEach((btn) => btn.addEventListener('click', () => {
      img.src = btn.dataset.zoom;
      img.alt = btn.querySelector('img') ? btn.querySelector('img').alt : '';
      zoom.showModal();
    }));
    zoom.addEventListener('click', (e) => { if (e.target === zoom || e.target.closest('[data-zoom-close]')) zoom.close(); });
  }

  /* ---------- Size guide + wall calculator ---------- */
  const guide = root.querySelector('[data-size-guide]');
  if (guide) {
    const allowance = parseFloat(guide.dataset.frameAllowance || '2');
    const sizes = (data.sizeValues || []).map((label) => {
      const m = label.match(/(\d+(?:\.\d+)?)\s*[×xX]\s*(\d+(?:\.\d+)?)/);
      return m ? { label, w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
    }).filter(Boolean);
    const furnitureInput = guide.querySelector('[data-guide-furniture]');
    const scene = guide.querySelector('[data-guide-scene]');
    const art = guide.querySelector('[data-guide-art]');
    const artLabel = guide.querySelector('[data-guide-art-label]');
    const furniture = guide.querySelector('[data-guide-furniture-shape]');
    const result = guide.querySelector('[data-guide-result]');
    const rows = guide.querySelector('[data-guide-rows]');
    const bestFor = (w) => (w <= 12 ? 'Desk, shelf or gallery wall' : w <= 16 ? 'Console, hallway or bedside' : w <= 24 ? 'Above a sofa, bed or mantel' : 'A statement wall');

    const currentSize = () => {
      if (data.sizeOption < 0) return sizes[0];
      const fs = root.querySelectorAll('[data-option]')[data.sizeOption];
      const v = fs && fs.querySelector('input:checked') ? fs.querySelector('input:checked').value : null;
      return sizes.find((s) => s.label === v) || sizes[0];
    };

    const draw = () => {
      if (!sizes.length) { scene.hidden = true; return; }
      const fw = Math.min(Math.max(parseFloat(furnitureInput.value) || 84, 20), 200);
      const size = currentSize();
      const wallW = Math.max(fw * 1.5, 72);
      const px = scene.clientWidth / wallW;
      const fwPx = fw * px;
      furniture.style.width = `${fwPx}px`;
      furniture.style.height = `${Math.min(34, fw * 0.4) * px}px`;
      const aw = (size.w + allowance * 2) * px;
      const ah = (size.h + allowance * 2) * px;
      art.style.width = `${aw}px`;
      art.style.height = `${ah}px`;
      art.style.bottom = `${scene.clientHeight * 0.18 + Math.min(34, fw * 0.4) * px + 9 * px}px`;
      artLabel.textContent = size.label;
      const ideal = fw * 0.62;
      const best = sizes.reduce((a, b) => (Math.abs(b.w + allowance * 2 - ideal) < Math.abs(a.w + allowance * 2 - ideal) ? b : a));
      result.innerHTML = `For a ${fw} in wide piece of furniture, we suggest <strong>${best.label}</strong>.`;
    };

    if (rows) {
      rows.innerHTML = sizes.map((s) => `<tr><th scope="row">${s.label}</th><td>${s.w + allowance * 2} × ${s.h + allowance * 2} in</td><td>${bestFor(s.w)}</td></tr>`).join('');
    }
    furnitureInput.addEventListener('input', draw);
    root.addEventListener('ms:variant-change', draw);
    document.addEventListener('click', (e) => { if (e.target.closest(`[data-drawer-open="${guide.id}"]`)) setTimeout(draw, 60); });
    window.addEventListener('resize', draw);
  }

  /* ---------- See it on your wall ---------- */
  const wall = root.querySelector('[data-wall]');
  const wallOpen = root.querySelector('[data-wall-open]');
  if (wall && wallOpen && typeof wall.showModal === 'function') {
    const stage = wall.querySelector('[data-wall-stage]');
    const room = wall.querySelector('[data-wall-room]');
    const piece = wall.querySelector('[data-wall-piece]');
    const scale = wall.querySelector('[data-wall-scale]');
    const photo = wall.querySelector('[data-wall-photo]');
    let pos = { x: 0.5, y: 0.38 };
    const place = () => {
      pos.x = Math.min(Math.max(pos.x, 0.05), 0.95);
      pos.y = Math.min(Math.max(pos.y, 0.08), 0.92);
      piece.style.width = `${scale.value}%`;
      piece.style.left = `${pos.x * 100}%`;
      piece.style.top = `${pos.y * 100}%`;
    };
    wallOpen.addEventListener('click', () => { wall.showModal(); place(); });
    wall.querySelector('[data-wall-close]').addEventListener('click', () => wall.close());
    wall.addEventListener('click', (e) => { if (e.target === wall) wall.close(); });
    scale.addEventListener('input', place);
    photo.addEventListener('change', () => {
      const file = photo.files && photo.files[0];
      if (!file) return;
      room.style.backgroundImage = `url("${URL.createObjectURL(file)}")`;
      stage.classList.add('has-photo');
    });
    let dragging = false;
    piece.addEventListener('pointerdown', (e) => { dragging = true; piece.setPointerCapture(e.pointerId); piece.classList.add('is-dragging'); });
    piece.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const r = stage.getBoundingClientRect();
      pos = { x: Math.min(Math.max((e.clientX - r.left) / r.width, 0.05), 0.95), y: Math.min(Math.max((e.clientY - r.top) / r.height, 0.08), 0.92) };
      place();
    });
    ['pointerup', 'pointercancel'].forEach((ev) => piece.addEventListener(ev, () => { dragging = false; piece.classList.remove('is-dragging'); }));
    piece.addEventListener('keydown', (e) => {
      const step = 0.02;
      if (e.key === 'ArrowLeft') pos.x -= step; else if (e.key === 'ArrowRight') pos.x += step;
      else if (e.key === 'ArrowUp') pos.y -= step; else if (e.key === 'ArrowDown') pos.y += step; else return;
      e.preventDefault(); place();
    });
  }
})();
